import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OurTeamRoutingModule } from './our-team-routing.module';
import {OurTeamComponent} from "../../app/layout/pages/our-team/our-team.component";


@NgModule({
  declarations: [OurTeamComponent],
  imports: [
    CommonModule,
    OurTeamRoutingModule
  ]
})
export class OurTeamModule { }
